import { Component, Input, ViewEncapsulation } from '@angular/core';
import { BaseContentEntity } from 'common/models';

@Component({
    selector: 'hvac-highlights',
    templateUrl: './highlights-content.component.html',
    styleUrls: ['./highlights-content.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class HighlightsContentComponent {
    @Input() data: BaseContentEntity;
}
